import React from 'react';
import './MyStyles/style.css';
import './MyStyles/responsive.css';

export const Banner = () => {
    return (
        <div>
            <section>

                    <div id="myCarousel" className="carousel slide" data-ride="carousel">
                        <div className="carousel-inner">
                            <div className="item active">
                                <div className="banner">
                                    <div className="banner-overlay"></div>
                                    <div className="container banner-content">
                                        <div className="row align-items-center">
                                            <div className="col-lg-7">
                                                <div className="offer-text">GIFT YOUR LOVED ONES A PACK FULL OF OTT FUN!</div>
                                                <div className="discount-text">Save 30% on 10 Vouchers & 50% on 10+ Vouchers</div>
                                                <div className="device-container">
                                                    <div className="text-center">
                                                        <span className="watch-on-any">Watch on any device</span>
                                                    </div>
                                                    <div className="device-icons d-flex">
                                                        <div className="honoe-me">
                                                            <img src="./Images/TV.png" alt="TV Icon"/>
                                                            <p>TV</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Laptop.png" alt="Desktop Icon"/>
                                                            <p>Desktop</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Mobile.png" alt="Mobile Icon"/>
                                                            <p>Mobile</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Laptop-1.png" alt="Laptop Icon"/>
                                                            <p>Laptop</p>
                                                        </div>
                                                        <div className="honoe-me">
                                                            <img src="./Images/Tablet.png" alt="Tablet Icon"/>
                                                            <p>Tablet</p>
                                                        </div>
                                                    </div>
                                            </div>

                                            </div>
                                            <div className="col-lg-5 text-center">
                                                <div className="banner-image banner-image-bottom-stretch">
                                                    <img 
                                                        src="./Images/Asia-cup-1-372-x-240.jpg" 
                                                        alt="Banner1" 
                                                        className="stretch-bottom-img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        </div>
                    </div>
            </section>
        </div>
    );
}